import * as actions from "Actions";
import * as api from "Api";

import { getAllowedMediaTypes } from "Utils";

export const fetchMedias = ({ type, limit, filterBy } = {}) => (
  dispatch,
  getState
) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;
  const allowedMediaTypes = getAllowedMediaTypes(navCommunity);
  let mediaType = null;
  type = filterBy && filterBy.type ? filterBy.type : type;
  mediaType = type.indexOf("CAT_") !== -1 ? "ALL" : type;
  if (token === "") {
    return api.getClientCredential().done(resp => {
      const help = typeof resp === "string" ? JSON.parse(resp) : resp;

      const clientToken = help.token.access_token;
      dispatch(actions.setAuthToken(clientToken));
      return dispatch(
        actions.fetchMediasByType(type)(
          api.getMedias({
            token: clientToken,
            type: mediaType,
            limit,
            lng,
            filterBy,
            allowedMediaTypes,
            community: null
          })
        )
      );
    });
  }
  return dispatch(
    actions.fetchMediasByType(type)(
      api.getMedias({
        token,
        type: mediaType,
        limit,
        lng,
        filterBy,
        allowedMediaTypes,
        community: navCommunity /*, sourceToken*/
      })
    )
  );
};

export const fetchMed = ({ type, limit, filterBy } = {}) => (
  dispatch,
  getState
) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;
  const allowedMediaTypes = getAllowedMediaTypes(navCommunity);
  let mediaType = null;
  if (type && type.indexOf("CAT_") !== -1) {
    mediaType = "ALL";
  } else if (type) {
    mediaType = type;
  }
  if (token === "") {
    return api.getClientCredential().done(resp => {
      const help = typeof resp === "string" ? JSON.parse(resp) : resp;

      const clientToken = help.token.access_token;
      dispatch(actions.setAuthToken(clientToken));

      return dispatch(
        actions.fetchMedias(
          api.getMedias({
            token: clientToken,
            type: mediaType,
            limit,
            lng,
            filterBy,
            allowedMediaTypes,
            community: null
          })
        )
      );
    });
  }
  return dispatch(
    actions.fetchMedias(
      api.getMedias({
        token,
        type: mediaType,
        limit,
        lng,
        filterBy,
        allowedMediaTypes,
        community: navCommunity /*, sourceToken*/
      })
    )
  );
};

export const fetchTopMedias = ({ limit } = {}) => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;
  const allowedMediaTypes = getAllowedMediaTypes(navCommunity);
  const mediaType = "ALL";
  const filterBy = { inTheNews: 1 };
  if (token === "") {
    return api.getClientCredential().done(resp => {
      const help = typeof resp === "string" ? JSON.parse(resp) : resp;

      const clientToken = help.token.access_token;
      dispatch(actions.setAuthToken(clientToken));

      return dispatch(
        actions.fetchTopMedias(
          api.getMedias({
            token: clientToken,
            type: mediaType,
            limit,
            lng,
            filterBy,
            allowedMediaTypes,
            community: null
          })
        )
      );
    });
  }
  return dispatch(
    actions.fetchTopMedias(
      api.getMedias({
        token,
        type: mediaType,
        limit,
        lng,
        filterBy,
        allowedMediaTypes,
        community: navCommunity /*, sourceToken*/
      })
    )
  );
};

export const fetchMyMedias = ({ type = "ALL", limit } = {}) => (
  dispatch,
  getState
) => {
  const { lng } = getState().params;
  const { token, navCommunity, user } = getState().auth;

  let allowedMediaTypes = getAllowedMediaTypes(navCommunity);

  if (allowedMediaTypes.length === 0) {
    allowedMediaTypes = ["IMAGE"];
  }

  return dispatch(
    actions.fetchMedias(
      api.getMyMedias({
        token,
        types: type === "ALL" ? allowedMediaTypes : [type],
        limit,
        lng,
        communityId: navCommunity.id,
        userId: user.id
      })
    )
  );
};

export const fetchMyFavorites = ({ type = "ALL", limit } = {}) => (
  dispatch,
  getState
) => {
  const { lng } = getState().params;
  const { token, navCommunity, user } = getState().auth;

  let allowedMediaTypes = getAllowedMediaTypes(navCommunity);

  if (allowedMediaTypes.length === 0) {
    allowedMediaTypes = ["IMAGE"];
  }

  return dispatch(
    actions.fetchMediasByType("IMAGE")(
      api.getMyFavorites({
        token,
        types: type === "ALL" ? allowedMediaTypes : [type],
        limit,
        lng,
        communityId: navCommunity.id,
        userId: user.id
      })
    )
  );
};

export const fetchInfiniteMedias = ({
  type,
  limit,
  offset,
  isFavorite = 0
} = {}) => (dispatch, getState) => {
  const { lng, currentNavPage } = getState().params;
  const { auth, filter } = getState();
  const { token, navCommunity } = auth;

  const allowedMediaTypes = getAllowedMediaTypes(navCommunity);

  const filterBy = filter.filterState;

  if (currentNavPage === "MY_MEDIAS") {
    filterBy.isPrivate = ["1", "0"];
  }
  return dispatch(
    actions.fetchInfiniteMediasByType(type === "LIBRARY" ? "ALL" : type)(
      type === "LIBRARY"
        ? api.getLibraryMedias({
            token,
            limit,
            offset,
            lng,
            community: navCommunity
          })
        : api.getMedias({
            token,
            type,
            limit,
            offset,
            lng,
            filterBy,
            allowedMediaTypes,
            isFavorite,
            community: navCommunity /*, sourceToken*/
          })
    )
  );
};

export const fetchUsedMedias = ({
  type,
  limit,
  offset,
  isFavorite = 0
} = {}) => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;

  return dispatch(
    actions.fetchUsedMedias(
      api.getUsedMedias({
        token,
        limit,
        offset,
        lng,
        community: navCommunity
      })
    )
  );
};

export const saveMedia = ({
  id,
  file,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  altFR,
  altEN,
  altNL,
  copyrightFR,
  copyrightEN,
  copyrightNL,
  tags,
  creator,
  taggedUsers,
  isPrivate,
  inTheNews,
  mediaStatus,
  csScope,
  overrideMainImage = false,
  onProgress,
  docType,
  mask,
  logo,
  logoPosition,
  logoSize,
  width,
  height,
  languages
} = {}) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;
  const { lng } = getState().params;

  return dispatch(
    actions.saveMedia(
      api.saveMedia({
        token,
        lng,
        id,
        file,
        titleFR,
        titleEN,
        titleNL,
        descriptionFR,
        descriptionEN,
        descriptionNL,
        altFR,
        altEN,
        altNL,
        copyrightFR,
        copyrightEN,
        copyrightNL,
        community: navCommunity,
        onProgress,
        tags,
        creator,
        taggedUsers,
        isPrivate,
        inTheNews,
        mediaStatus,
        csScope,
        overrideMainImage,
        docType,
        mask,
        logo,
        logoPosition,
        logoSize,
        width,
        height,
        languages
      })
    )
  );
};

export const uploadMediaFiles = (
  files = [],
  docType = null,
  mask = null,
  logo = null,
  logoPosition = null,
  logoSize = null,
  languages = ["FR", "EN", "NL"]
) => (dispatch, getState) => {
  // Add meta data to  files (id, upload progress, error, ...)
  const uploadingMedias = files.map((file, i) => ({
    id: `DROPPED-${i}-${performance.now()}`,
    file,
    progress: 0,
    error: null
  }));

  // Add uploading medias to store
  dispatch(actions.addUploadingMedias(uploadingMedias));

  // Upload the files
  uploadingMedias.forEach(media => {
    dispatch(
      saveMedia({
        file: media.file,
        docType,
        mask,
        logo,
        logoPosition,
        logoSize,
        languages,
        onProgress: progress => {
          const { items } = getState().medias.uploading;

          let oldMedia = null;
          let oldMediaIndex = -1;

          for (let i = 0; i < items.length; i++) {
            if (items[i].id === media.id) {
              oldMedia = items[i];
              oldMediaIndex = i;
              break;
            }
          }

          if (!oldMedia || oldMediaIndex === -1) {
            return;
          }

          const newMedia = { ...oldMedia, progress };
          const newMedias = items.concat();
          newMedias[oldMediaIndex] = newMedia;

          dispatch(actions.setUploadingMedias(newMedias));
        }
      })
    )
      .then(() => {
        const { items } = getState().medias.uploading;
        const oldMedias = items.filter(m => m.id !== media.id);
        dispatch(actions.setUploadingMedias(oldMedias));
      })
      .catch(() => {
        const { items } = getState().medias.uploading;
        const oldMedias = items.filter(m => m.id !== media.id);
        dispatch(actions.setUploadingMedias(oldMedias));
      });
  });
};

export const addToLibrary = media => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;

  return dispatch(
    actions.addToLibrary(
      api.addToLibrary({
        token,
        media: media.id,
        owner: media.organization.id,
        organization: navCommunity.id,
        isOwner: 0,
        isAuto: 0,
        csScope: media.csScope
      })
    )
  );
};

export const deleteMedias = mediaIds => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.deleteMedias(
        api.deleteMedias({
          token,
          mediaIds
        })
      )
    );
  };
};

export const maskMedias = mediaIds => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.maskMedias(
        api.maskMedias({
          token,
          mediaIds
        })
      )
    );
  };
};

export const archiveMedias = mediaIds => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.archiveMedias(
        api.archiveMedias({
          token,
          mediaIds
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/media.js